// Load Active Admin's styles into Webpacker,
// see `active_admin.scss` for customization.
import "../stylesheets/bootstrap";
import "../stylesheets/active_admin";
import "../stylesheets/tables";
import "../stylesheets/scopes";
import "../stylesheets/nav";
import "../stylesheets/filters";
import "../stylesheets/typography";
import 'bootstrap-icons/font/bootstrap-icons.css'

import "@activeadmin/activeadmin";
import "@fortawesome/fontawesome-free/css/all.css";
import 'arctic_admin'
